/**
 * Performance Fixes for Velvetica Store
 * Reduces forced reflows from utilities.js and jumbo-text.js
 */

// Fix 1: Batch DOM reads/writes using requestAnimationFrame
// This prevents layout thrashing from jumbo-text.js

(function() {
  'use strict';

  // Override getBoundingClientRect batching
  // Queues layout reads to happen together
  let pendingReads = [];
  let pendingWrites = [];
  let frameRequested = false;

  function scheduleFrame() {
    if (!frameRequested) {
      frameRequested = true;
      requestAnimationFrame(function() {
        // Execute all reads first (no reflow)
        const reads = pendingReads.splice(0);
        reads.forEach(fn => fn());
        
        // Then execute all writes (single reflow)
        const writes = pendingWrites.splice(0);
        writes.forEach(fn => fn());
        
        frameRequested = false;
      });
    }
  }

  // Make available globally for theme scripts
  window.ThemePerf = {
    read: function(fn) {
      pendingReads.push(fn);
      scheduleFrame();
    },
    write: function(fn) {
      pendingWrites.push(fn);
      scheduleFrame();
    }
  };

  // Fix 2: Optimize ResizeObserver usage
  // Replaces multiple resize listeners with one shared observer
  const resizeCallbacks = new Map();
  
  const sharedResizeObserver = new ResizeObserver(function(entries) {
    // Batch all resize callbacks in one frame
    requestAnimationFrame(function() {
      entries.forEach(function(entry) {
        const callbacks = resizeCallbacks.get(entry.target);
        if (callbacks) {
          callbacks.forEach(fn => fn(entry));
        }
      });
    });
  });

  window.ThemePerf.observeResize = function(element, callback) {
    if (!resizeCallbacks.has(element)) {
      resizeCallbacks.set(element, []);
      sharedResizeObserver.observe(element);
    }
    resizeCallbacks.get(element).push(callback);
  };

  window.ThemePerf.unobserveResize = function(element) {
    sharedResizeObserver.unobserve(element);
    resizeCallbacks.delete(element);
  };

  // Fix 3: Debounce scroll events that cause reflows
  let scrollTimeout;
  let lastScrollY = window.scrollY;
  
  window.addEventListener('scroll', function() {
    // Cache scroll position to avoid repeated reads
    lastScrollY = window.scrollY;
    
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function() {
      // Dispatch batched scroll event after scroll stops
      window.dispatchEvent(new CustomEvent('scroll:end', {
        detail: { scrollY: lastScrollY }
      }));
    }, 100);
  }, { passive: true });

  // Fix 4: Lazy initialize non-critical components
  // Delays jumbo-text and similar until after LCP
  function afterLCP(callback) {
    if ('PerformanceObserver' in window) {
      const observer = new PerformanceObserver(function(list) {
        const entries = list.getEntries();
        if (entries.length > 0) {
          observer.disconnect();
          // Wait one more frame after LCP before running
          requestAnimationFrame(callback);
        }
      });
      
      try {
        observer.observe({ type: 'largest-contentful-paint', buffered: true });
      } catch(e) {
        // Fallback if LCP observer not supported
        setTimeout(callback, 2500);
      }
    } else {
      setTimeout(callback, 2500);
    }
  }

  // Make afterLCP available for deferred init
  window.ThemePerf.afterLCP = afterLCP;

})();